import PreferencesStore from '@store/modules/ui/user/preferences/preferencesIndex';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import { computed } from '@vue/composition-api';

export function usePredefinedStakes() {
    const preferencesStore = useVuexStore<typeof PreferencesStore>('ui/user/preferences');

    const sortedPredefinedStakes = computed(() => [...preferencesStore.getter('predefinedStakes').value]
        .sort((a, b) => a.value - b.value));
    const predefinedStakeValues = computed(() => sortedPredefinedStakes.value.map((stake) => stake.value));
    const firstPredefinedStake = sortedPredefinedStakes.value[0];

    return {
        sortedPredefinedStakes,
        predefinedStakeValues,
        firstPredefinedStake,
    };
}
